import GanymedePageContainer from "../../components/ganymede/PageContainer";
import GanymedeDocumentHeader from "../../components/ganymede/DocumentHeader";
import GanymedePageFooter from "../../components/ganymede/PageFooter";
import "./contracts.css";
import { useNavigate } from "react-router-dom";

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <>
      <GanymedePageContainer className={"service-agreement-container"}>
        <div className={"InvoiceHeader"}>
          <GanymedeDocumentHeader title={"PRIVACY POLICY"} />
        </div>
        <div className={"service-agreement-scroll-container"}>
          <p>Last revised: May 5th, 2020.</p>
          <p>
            Snout, Inc. ("Snout") is committed to maintaining the
            confidentiality, integrity and security of any personal information
            about our users. This Privacy &amp; Security Policy explains how we
            protect personal information provided through our website snout.com
            (the "Site") and how we use that information in connection with our
            service offered through the Site (the "Service"). "Personal
            information" for purposes of this Policy means information that
            identifies you, such as your name, address, phone number, fax number
            or email address.
          </p>
          <p>
            Snout stresses its privacy and security standards to guard against
            identity theft and provide security for your personal information.
            We regularly re-evaluate our privacy and security policies and adapt
            them as necessary to deal with new challenges.
          </p>

          <h2>Your Privacy is not for sale</h2>
          <p>
            Snout uses and discloses your personal information only as follows:
          </p>
          <ul>
            <li>to provide the Service;</li>
            <li>to analyze site usage and improve the Service;</li>
            <li>for internal system administration;</li>
            <li>
              to deliver to you any administrative notices, health alerts and
              communications relevant to your use of the Service;
            </li>
            <li>
              to fulfill your requests for certain products and services;
            </li>
            <li>
              for market research, project planning, troubleshooting problems,
              detecting and protecting against error, fraud or other criminal
              activity;
            </li>
            <li>
              to third-party contractors that provide services to Snout and are
              bound by these same privacy restrictions;
            </li>
            <li>
              to enforce Snout's{" "}
              <a href="/membership-agreement">Terms of Service</a> and other
              legal rights and remedies;
            </li>
            <li>if Snout has your valid consent to do so;</li>
            <li>
              to comply with a valid subpoena, legal order, court order, legal
              process, or other legal obligation;
            </li>
            <li>
              as necessary to pursue available legal remedies or defend legal
              claims; and
            </li>
            <li>
              as otherwise set forth in this Privacy and Security Policy.
            </li>
          </ul>
          <p>
            In addition, Snout may transfer your personal information to an
            affiliate, a subsidiary or a third party in the event of any
            reorganization, merger, acquisition or sale, joint venture,
            assignment, transfer or other disposition of all or any portion of
            Snout's business, assets or stock, including, without limitation, in
            connection with any bankruptcy or similar proceeding.
          </p>

          <h2>We limit the collection and use of personal information</h2>
          <p>
            Certain areas and features of snout.com are available to you without
            registration or the need to provide to us any information. However,
            other features of the Site or the Service may require registration,
            which involves provision to Snout of an email address, a password
            and a username (collectively the "Registration Information"). In
            order to benefit from the full functionality of the Service, you
            also must provide your pet and your pet's third-party veterinarian
            information ("VCPR Information") to allow Snout to access your pet's
            health data at those other veterinarian institutions for your use.
          </p>
          <p>
            From time to time we may request other personal information to
            provide you with other benefits of the Service. In all such
            instances, you will be given the opportunity to provide or to
            decline to provide that information, and it will be used only for
            the stated purpose. Snout may take anonymous or aggregate personal
            information and disclose such data only in a non-personally
            identifiable manner to:
          </p>
          <ul>
            <li>
              Organizations approved by Snout that conduct research into health;
              and
            </li>
            <li>
              Users of the Service for purposes of comparison of their animal's
              health situation relative to the broader community.
            </li>
          </ul>
          <p>
            Such information does not identify you individually. Access to your
            Registration Information, VCPR Information, and any other personal
            information you provide is strictly restricted and used in
            accordance with specific internal procedures and safeguard governing
            access, in order to operate, develop or improve the Service. These
            individuals have been selected in accordance with our security
            policies and practices and are bound by confidentiality obligations.
            They may be subject to discipline, including termination and
            criminal prosecution, if they fail to meet these obligations.
          </p>

          <h2>Changes to your Registration Information</h2>
          <p>
            If your Registration Information changes during your subscription to
            Snout, you may update it any time via the Service.
          </p>

          <h2>
            Online session information and use is only used to improve your
            experience
          </h2>
          <p>
            When you visit snout.com, we may collect technical and navigational
            information, such as computer browser type, Internet protocol
            address, pages visited, and average time spent on our Site. This
            information may be used, for example, to alert you to software
            compatibility issues, or it may be analyzed to improve our Web
            design and functionality.
          </p>
          <p>
            snout.com may set and access cookies on your computer to track and
            store preferential information about you. If you choose to eliminate
            cookies, the full functionality of the Service may be impaired for
            you. We encode our cookies so that only we can interpret the
            information stored in them. snout.com may use Web beacons to help us
            measure and analyze Site usage and activity to improve the Service.
          </p>
          <p>
            We may use and permit third party service providers to use cookies,
            web beacons, and other technologies to help Snout analyze certain
            online activities, such as the ones described previously. We do not
            share any personal information about our customers with these third
            party service providers, and these service providers do not collect
            such information on our behalf. Our third party service providers
            are required to comply fully with this Privacy and Security Policy.
          </p>

          <h2>Snout blog</h2>
          <p>
            If you comment on the blog on our Site, you should be aware that any
            information you submit there can be read, collected or used by other
            users and could be used to send you unsolicited messages. We are not
            responsible for the personal information you choose to submit in
            these forums.
          </p>

          <h2>You can transport or delete your data</h2>
          <p>
            Your data is yours. You can remove it anytime you want. When you
            request us to delete your account for the Service, your data will be
            permanently expunged from our primary production servers and further
            access to your account will not be possible. We will no longer
            contact your vet with your VCPR Information.
          </p>

          <h2>Email communications from us</h2>
          <p>
            From time to time we may provide our registered customers with email
            alerts or email newsletters. Snout subscribers have the ability to
            opt-out of receiving our emails by following the instructions in the
            emails. Opting out in this manner will not end transmission of
            service-related emails, such as email alerts.
          </p>

          <h2>Your data is secure and communications are encrypted.</h2>
          <p>
            Our servers are in a secure facility. We use a combination of
            firewall barriers, encryption techniques and authentication
            procedures, among others, to maintain the security of your online
            session and to protect Snout accounts and systems from unauthorized
            access. All backup drives and tapes also are encrypted.
          </p>
          <p>
            From the time you submit your Login ID and Password, the
            communications between your computer and snout.com are encrypted.
            This enables client and server application communications to
            minimize eavesdropping, tampering and message forgery.
          </p>
          <p>
            Our databases are protected from general employee access both
            physically and logically. We transmit information, such as your
            Registration Information, securely. We encrypt your Service password
            so that your password cannot be recovered, even by us. No employee
            may put any sensitive content on any insecure machine.
          </p>

          <h2>
            We post updates on our website whenever there is a change to our
            Privacy and Security Policy
          </h2>
          <p>
            We update this Privacy &amp; Security Policy periodically. The date
            last revised appears at the top of the Policy. Changes take effect
            immediately upon posting.
          </p>

          <h2>Contact us if you have any questions or concerns</h2>
          <p>
            If you have questions, comments, concerns or feedback regarding this
            Privacy and Security Policy or any other privacy or security
            concern, send an email to{" "}
            <a href="mailto:support@snout.com">support@snout.com</a>.
          </p>
        </div>

        {window.history.length > 1 && (
          <button
            className="back-btn my-6 sm:mb-0 w-full sm:w-auto"
            style={{ alignSelf: "center" }}
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        )}
      </GanymedePageContainer>
      <GanymedePageFooter />
    </>
  );
}

export default PrivacyPolicy;
